// Foot.jsx
// OPTIMIZATIONS APPLIED:
// 1. Removed react-icons/fa (was 1,379 KB) → replaced with inline SVGs
// 2. Removed "bootstrap/dist/css/bootstrap.min.css" import (import it once in main.jsx only)
// 3. Added loading="lazy" on the logo image
// 4. Used <link rel="preload"> friendly asset reference via import

import Logo from "../../assets/IEEPL-Logo.png";
import Logo_80w from "../../assets/IEEPL-Logo-80w.webp";
import Logo_160w from "../../assets/IEEPL-Logo-160w.webp";
import "./foot.css";
// ❌ REMOVED: import "bootstrap/dist/css/bootstrap.min.css";
//    → Add this ONCE in your main.jsx: import "bootstrap/dist/css/bootstrap.min.css";
// ❌ REMOVED: import { FaLinkedin, FaFacebook, FaInstagram } from "react-icons/fa";
//    → Replaced with inline SVGs below (saves ~1.38 MB)

// Inline SVG icons — pixel-perfect match to Font Awesome's LinkedIn, Facebook, Instagram
const LinkedInIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-label="LinkedIn"
  >
    <path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z" />
  </svg>
);

const FacebookIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 320 512"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-label="Facebook"
  >
    <path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z" />
  </svg>
);

const InstagramIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-label="Instagram"
  >
    <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
  </svg>
);

function Foot() {
  return (
    <footer className="main-container">
      <section className="ideasfooter">
        <div className="container-fluid">
          <div className="row">
            {/* Column 1 — Logo & Description */}
            <div className="col-lg-4 mb-3 mt-2 col-md-6 col-sm-12">
              <div className="Ideasfootelogo" style={{ borderRadius: "50%" }}>
                <img
                  src={Logo}
                  srcSet={`${Logo_80w} 80w, ${Logo_160w} 160w`}
                  sizes="63px"
                  style={{ borderRadius: "50%" }}
                  className="bg-white"
                  alt="IdeasLogo"
                  width="63"
                  height="63"
                  loading="lazy"
                />
              </div>
              <h2>IDEAS ELECTRICALS & ENGINEERS LIMITED</h2>
              <p>
                We are a leading player in Engineering, Procurement &
                Construction, operating in various verticals with a focus on
                Power & Power related Projects led by Technocrats having
                cumulative experience of more than 2 decades.
              </p>
            </div>

            {/* Column 2 — Nav Links */}
            <div className="col-lg-2 mb-3 mt-2 col-md-6 col-sm-12">
              <ul className="FooterLinks">
                <li className="dropdown">
                  <a
                    className="foor-navbar dropdown-toggle"
                    href="/about"
                    id="footerDropdownAbout"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    About Us
                  </a>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="footerDropdownAbout"
                  >
                    <div className="big-dropdown">
                      <div className="col">
                        <li>
                          <a className="dropdown-item" href="/about#AboutHero">
                            Who We Are
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="/about#directors">
                            Directors
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="/about#our-teams">
                            Our Team
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            href="/about#vision-mission"
                          >
                            Vision
                          </a>
                        </li>
                      </div>
                      <div className="col">
                        <li>
                          <a className="dropdown-item" href="/about#corevalue">
                            Core Value
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="/about#footprints">
                            Footprints
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="/about#awards">
                            Awards & Recognition
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="/portfolio">
                            Benchmark
                          </a>
                        </li>
                      </div>
                    </div>
                  </ul>
                </li>

                <li className="dropdown">
                  <a
                    className="foor-navbar dropdown-toggle"
                    href="/EpcContacts"
                    id="footerDropdownBusiness"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Business Areas
                  </a>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="footerDropdownBusiness"
                  >
                    <div className="big-dropdown">
                      <div className="col">
                        <li>
                          <a className="dropdown-item" href="/Newsubstation">
                            Substation
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="/Transmisionline">
                            Transmission Line
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="/Scement">
                            Cement
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="/Ssolar">
                            Solar
                          </a>
                        </li>
                      </div>
                      <div className="col">
                        <li>
                          <a className="dropdown-item" href="/Electricle">
                            Electrical & Instrumentation
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="/Cogen">
                            Cogen & Sugar
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="/EpcContacts">
                            EPC Contracts
                          </a>
                        </li>
                      </div>
                    </div>
                  </ul>
                </li>
                {/* <li className="dropdown">
                  <a
                    className="foor-navbar dropdown-toggle"
                    href="#"
                    id="footerDropdownInvestors"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Investors
                  </a>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="footerDropdownInvestors"
                  >
                    <li>
                      <a className="dropdown-item" href="/Policies">
                        Policies
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="/GreenBuilding">
                        Sustainability
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="/board-committee">
                        Board Committee
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="/Csractivity">
                        CSR Activities
                      </a>
                    </li>
                  </ul>
                </li> */}

                <li>
                  <a className="FootLink" href="/OngoingProject">
                    Projects
                  </a>
                </li>
                <li>
                  <a className="FootLink" href="/career">
                    Career
                  </a>
                </li>
                <li>
                  <a className="FootLink" href="/Media">
                    Media
                  </a>
                </li>
                <li>
                  <a className="FootLink" href="/blogs">
                    Blogs
                  </a>
                </li>
              </ul>
            </div>

            {/* Column 3 — Address */}
            <div className="col-lg-4 col-md-6 mb-3 mt-2 col-sm-12 AddresFoot">
              <h3>Address</h3>
              <p>
                IDEAS HOUSE, Plot No 32, Gut No 44, Near Bajaj Hospital, Uma
                Gopal Nagar, Beed Bypass, Chhatrapati Sambhajinagar - 431010
              </p>
              <h3>Email</h3>
              <p>info@ideasengineers.com</p>
              <h3>Call us at</h3>
              <p>+91 240-2453636 / 2452828 / 8007803636</p>
            </div>

            {/* Column 4 — Social Links */}
            <div className="col-lg-2 col-md-6 col-sm-12 mb-3 mt-2 Social">
              <h3>Social Links</h3>
              <ul className="SocialLinks">
                <li>
                  <a
                    href="https://in.linkedin.com/company/ideas-electricals-engineers-pvt-ltd"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {/* ✅ Inline SVG — Font Awesome LinkedIn (saves 1.38 MB) */}
                    <LinkedInIcon className="social-icon linkedin" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/profile.php?id=61560041551891"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FacebookIcon className="social-icon facebook" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/ideas_engineers/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <InstagramIcon className="social-icon instagram" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <div className="footNote">
        <p>© 2026 by IDEAS ELECTRICALS & ENGINEERS LIMITED.</p>
      </div>
    </footer>
  );
}

export default Foot;